import React from 'react'

const PasswordResetIllustration = props => (
  <svg
    {...props}
    width="497"
    height="496"
    viewBox="0 0 497 496"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_13101_108294)">
      <path
        d="M323.834 89H110.005C95.5256 89 83.8184 100.734 83.8184 115.247V316.61C83.8184 331.126 95.5256 342.861 110.005 342.861H323.834C338.313 342.861 350.02 331.126 350.02 316.61V115.247C350.02 100.734 338.266 89 323.834 89Z"
        fill="#C2D9F0"
      />
      <path
        d="M143.169 119.294H356.998C371.154 119.294 382.684 130.804 382.684 145.041V346.404C382.684 360.645 371.2 372.154 356.998 372.154H143.169C128.967 372.154 117.482 360.645 117.482 346.404V145.041C117.482 130.803 128.967 119.294 143.169 119.294Z"
        fill="white"
        stroke="#E2E2FC"
      />
      <path
        d="M155.881 154.606C155.881 160.296 151.287 164.899 145.617 164.899C139.944 164.899 135.35 160.296 135.35 154.606C135.35 148.92 139.944 144.317 145.617 144.317C151.287 144.317 155.881 148.92 155.881 154.606Z"
        fill="#F9F9FF"
        stroke="#E2E2FC"
      />
      <path
        d="M187.147 154.606C187.147 160.296 182.549 164.899 176.879 164.899C171.209 164.899 166.615 160.296 166.615 154.606C166.615 148.92 171.209 144.317 176.879 144.317C182.549 144.317 187.147 148.921 187.147 154.606Z"
        fill="#F9F9FF"
        stroke="#E2E2FC"
      />
      <path
        d="M218.459 154.606C218.459 160.296 213.862 164.899 208.192 164.899C202.522 164.899 197.928 160.296 197.928 154.606C197.928 148.92 202.522 144.317 208.192 144.317C213.862 144.317 218.459 148.921 218.459 154.606Z"
        fill="#F9F9FF"
        stroke="#E2E2FC"
      />
      <path
        d="M215.172 194.251L186.974 239.785C182.938 246.303 181.79 254.196 183.757 261.599L197.085 311.578C201.056 326.516 216.385 335.431 231.324 331.42L295.2 314.343C310.139 310.362 318.999 294.998 315.027 280.025L301.7 230.046C299.733 222.643 294.776 216.361 288.046 212.741L240.972 187.342C231.881 182.472 220.588 185.465 215.172 194.251Z"
        fill="#004360"
      />
      <path
        d="M229.023 194.414C231.585 193.723 234.31 194.053 236.674 195.303L283.745 220.702C288.277 223.171 291.593 227.384 292.938 232.382L306.266 282.395C308.957 292.529 302.95 302.891 292.87 305.622L228.959 322.665C218.848 325.366 208.51 319.345 205.786 309.242L192.488 259.263C191.177 254.265 191.965 248.966 194.656 244.556L222.82 199.022C224.233 196.75 226.431 195.105 229.023 194.414ZM226.693 185.663C221.903 186.947 217.799 190.008 215.172 194.251L186.974 239.785C182.938 246.303 181.79 254.196 183.757 261.599L197.085 311.578C201.056 326.516 216.385 335.431 231.324 331.42L295.2 314.343C310.139 310.362 318.999 294.998 315.027 280.025L301.7 230.046C299.733 222.643 294.776 216.361 288.046 212.741L240.972 187.342C236.576 184.972 231.487 184.379 226.693 185.663Z"
        fill="#E2E2FC"
      />
      <path
        opacity="0.2"
        d="M269.983 232L203.818 251.02L220.653 319L286.818 299.98L269.983 232Z"
        fill="#1D2943"
      />
      <path
        d="M273.98 225L207.818 244.02L224.653 312L290.818 292.98L273.98 225Z"
        fill="white"
      />
      <path
        d="M252.398 282.232L183.397 260.285L197.051 311.547C201.026 326.482 216.355 335.401 231.29 331.386L295.136 314.309C310.071 310.328 318.935 294.964 314.963 280.025L301.306 228.766L252.398 282.232Z"
        fill="#E2E2FC"
      />
      <path
        d="M248.294 266.833L200.401 319.246C206.935 329.642 219.44 334.577 231.29 331.42L295.137 314.309C306.987 311.152 315.392 300.623 315.884 288.351L248.294 266.833Z"
        fill="#E2E2FC"
      />
      <path
        d="M246.161 301.873L267.564 296.149C270.585 295.324 273.669 297.136 274.488 300.16C275.31 303.187 273.506 306.283 270.486 307.103L249.083 312.827C246.062 313.651 242.978 311.843 242.155 308.816C241.337 305.755 243.141 302.663 246.161 301.873Z"
        fill="#004360"
      />
      <path
        d="M250.229 306.609L266.381 302.302"
        stroke="#1D2943"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M200.367 319.474L237.986 277.822"
        stroke="#1D2943"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M262.572 271.372L315.619 288.218"
        stroke="#1D2943"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M193.148 262.389L184.121 259.658"
        stroke="#1D2943"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M293.988 235.74L300.684 228.865"
        stroke="#1D2943"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M402.151 353.026L336.819 332L354.462 398.346L363.779 381.871L381.66 400.764L403.105 380.381L385.224 361.487L402.151 353.026Z"
        fill="#FFA4B5"
      />
      <path
        d="M56.894 343L22.4672 354.565L58.3808 362.063L20.8184 401.239L66.8804 391.86L69.098 427.399L88.1096 404.905"
        stroke="#E2E2FC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M382.818 89.938L383.661 52L407.99 85.8822L450.542 63.074L426.983 103.166L465.096 117.502L423.322 130.665L445.448 150.399"
        stroke="#E2E2FC"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M429.263 258.942C435.581 258.942 440.704 253.807 440.704 247.471C440.704 241.135 435.581 236 429.263 236C422.941 236 417.818 241.135 417.818 247.471C417.818 253.807 422.941 258.942 429.263 258.942Z"
        fill="#E2E2FC"
      />
      <path
        d="M456.007 282.421C460.694 282.421 464.489 278.614 464.489 273.92C464.489 269.226 460.694 265.419 456.007 265.419C451.323 265.419 447.525 269.226 447.525 273.92C447.525 278.614 451.323 282.421 456.007 282.421Z"
        fill="white"
      />
      <path
        d="M182.074 70.5504C187.182 70.5504 191.326 66.3972 191.326 61.277C191.326 56.1532 187.182 52 182.074 52C176.962 52 172.818 56.1532 172.818 61.277C172.818 66.3972 176.962 70.5504 182.074 70.5504Z"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M345.026 176.778C348.382 178.693 350.95 181.239 352.744 184.422C354.538 187.605 355.372 191.118 355.246 194.961C355.142 197.795 354.616 200.217 353.639 202.212C352.676 204.216 351.4 205.71 349.803 206.71C348.206 207.71 346.403 208.18 344.386 208.096C342.721 208.04 341.29 207.644 340.132 206.908C338.951 206.18 338.111 205.128 337.596 203.744C335.951 206.433 333.364 207.708 329.804 207.594C327.948 207.535 326.237 206.974 324.663 205.927C323.089 204.879 321.849 203.446 320.952 201.614C320.055 199.781 319.65 197.704 319.724 195.374C319.797 193.044 320.355 191.004 321.352 189.231C322.365 187.465 323.676 186.125 325.326 185.21C326.96 184.286 328.724 183.854 330.611 183.929C333.391 184.024 335.539 185.004 337.086 186.846L337.167 184.539L344.867 184.8L344.36 199.207C344.322 200.207 344.494 200.951 344.854 201.408C345.214 201.864 345.707 202.101 346.349 202.126C348.335 202.194 349.41 199.787 349.575 194.906C349.682 191.919 349.072 189.235 347.748 186.854C346.423 184.472 344.51 182.594 342.001 181.196C339.493 179.798 336.569 179.05 333.246 178.924C329.939 178.806 326.987 179.411 324.369 180.747C321.758 182.068 319.696 183.963 318.192 186.417C316.688 188.87 315.882 191.648 315.781 194.772C315.672 197.95 316.264 200.817 317.562 203.397C318.869 205.962 320.757 208 323.241 209.482C325.726 210.964 328.618 211.772 331.925 211.89C335.294 212.002 338.444 211.423 341.398 210.145L342.979 215.259C341.548 215.902 339.814 216.388 337.806 216.732C335.799 217.077 333.787 217.207 331.762 217.138C327.202 216.986 323.206 215.894 319.797 213.894C316.372 211.886 313.784 209.195 311.993 205.82C310.201 202.446 309.371 198.704 309.533 194.571C309.67 190.485 310.765 186.817 312.801 183.6C314.836 180.382 317.64 177.872 321.213 176.106C324.786 174.341 328.879 173.539 333.478 173.692C337.794 173.834 341.669 174.862 345.026 176.778ZM335.468 199.944C336.368 199.025 336.839 197.71 336.911 195.977C336.967 194.273 336.582 192.937 335.756 191.97C334.914 190.994 333.814 190.481 332.431 190.437C331.049 190.393 329.919 190.827 329.026 191.731C328.149 192.643 327.678 193.958 327.607 195.653C327.55 197.357 327.928 198.708 328.746 199.69C329.564 200.673 330.657 201.202 332.055 201.253C333.422 201.289 334.567 200.863 335.468 199.944Z"
        fill="#1D2943"
      />
      <path
        d="M27.8184 281C20.653 281 14.8184 275.171 14.8184 268.013C14.8184 260.854 20.653 255 27.8184 255C34.9837 255 40.8184 260.829 40.8184 268.013C40.8184 275.171 34.9837 281 27.8184 281ZM27.8184 260.113C23.468 260.113 19.9365 263.641 19.9365 268.013C19.9365 272.359 23.468 275.887 27.8184 275.887C32.1687 275.887 35.7002 272.359 35.7002 268.013C35.7002 263.641 32.1687 260.113 27.8184 260.113Z"
        fill="#4F5B94"
      />
      <path
        d="M93.0548 216.436L51.8024 216.494C45.6788 216.483 40.7648 211.561 40.8188 205.51L40.8404 123.067C40.8512 116.929 45.7652 112.004 51.8024 112.058L93.0548 112C99.1784 112.011 104.092 116.936 104.035 122.987L104.017 205.431C104.046 211.435 99.1316 216.364 93.0548 216.436Z"
        fill="#1D2943"
      />
      <path
        d="M89.1448 188.407L56.1652 188.417C52.6732 188.425 49.84 185.56 49.8328 182.06L49.8184 155.358C49.8112 151.858 52.6696 149.018 56.1616 149.011L89.1376 149C92.6296 148.993 95.4628 151.858 95.47 155.358L95.488 182.06C95.4916 185.56 92.6368 188.399 89.1448 188.407Z"
        fill="#FFA4B5"
      />
      <path
        d="M89.1592 141.351L56.1832 141.362C52.6912 141.369 49.8544 138.504 49.8508 135.004L49.8184 127.358C49.8148 123.858 52.6696 121.018 56.1616 121.011L89.1412 121C92.6332 120.993 95.4664 123.858 95.4736 127.358L95.5024 135.004C95.5096 138.504 92.7376 141.301 89.1592 141.351Z"
        fill="#E2E2FC"
      />
    </g>
    <defs>
      <clipPath id="clip0_13101_108294">
        <rect
          width="496"
          height="496"
          fill="white"
          transform="translate(0.818359)"
        />
      </clipPath>
    </defs>
  </svg>
)

export default PasswordResetIllustration
